import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ed{color:var(--brand-primary);}.ssr-plugin'
import { styled, type Style } from 'inlines'
import type { ReactNode } from 'react'
import { Text } from '../typography/Text'

export type InputFieldProps = {
  children: ReactNode
  label?: string
  labelStyle?: Style
  required?: boolean
  errorMessage?: string
  style?: Style
  gap?: string | number
}

export const InputField = ({
  children,
  label,
  labelStyle,
  required,
  errorMessage,
  style,
  gap = '0.38rem',
}: InputFieldProps) => {
  return (
    <styled.div className="d e a8"
      style={{
        gap,
        '&:has(:disabled)': {
          cursor: 'not-allowed',
        },
        ...style,
      }}
    >
      {label && (
        <Text.Medium
          style={{ color: 'var(--palette-blue-500)', ...labelStyle }}
        >
          {label}
          {required && ' '}
          {required && (
            <span className="ed">
              *
            </span>
          )}
        </Text.Medium>
      )}
      {children}
      {errorMessage && <Text.FormError>{errorMessage}</Text.FormError>}
    </styled.div>
  )
}
